var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#4b4b4b}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_609",
    transform: "translate(302.118 -70.042)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4031",
    d: "M-294.131 70.042a8.02 8.02 0 0 1 8.013 8.063 8.025 8.025 0 0 1-7.977 7.937 8.023 8.023 0 0 1-8.023-8.037 8.029 8.029 0 0 1 7.987-7.963zm.009 1.6a6.424 6.424 0 0 0-6.394 6.418 6.4 6.4 0 0 0 6.4 6.379 6.411 6.411 0 0 0 6.4-6.422 6.433 6.433 0 0 0-6.406-6.375z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4032",
    d: "M-176.472 142.151v-2.231c0-.136.032-.187.177-.183.425.01.85.008 1.275 0 .121 0 .153.041.153.157v4.495c0 .117-.033.157-.153.156-.43-.006-.861-.006-1.291 0-.131 0-.161-.045-.16-.166.002-.74-.001-1.479-.001-2.228z",
    className: "cls-1",
    transform: "translate(-118.446 -65.702)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4033",
    d: "M-174.848 252.347v.669c0 .1-.022.146-.132.145h-1.339c-.094 0-.132-.03-.132-.129v-1.355c0-.1.04-.126.133-.125.446 0 .893.005 1.339 0 .112 0 .133.045.131.142v.653z",
    className: "cls-1",
    transform: "translate(-118.468 -171.111)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.b535b1b539512162e02e8fd5a00f92b8.svg";
export { ForwardRef as ReactComponent };